var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "54px",
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Similar-apartments-on-other-floors",
    transform: "translate(-1053.000000, -103.000000)",
    fill: "#232D35",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parking-sign-(3)-copy",
    transform: "translate(1053.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9576957,0 L6.9836087,0 C3.45365217,0 0.594,2.86082609 0.594,6.3896087 L0.594,47.5528696 C0.594,51.0816522 3.45482609,53.9413043 6.9836087,53.9413043 L46.9576957,53.9413043 C50.4876522,53.9413043 53.3461308,51.0804783 53.3461308,47.5528696 L53.3461308,6.3896087 C53.3473043,2.85965217 50.4876522,0 46.9576957,0 Z M49.41,46.5280435 C49.41,48.4497391 47.8533913,50.004 45.9340435,50.004 L7.93447826,50.004 C6.01395652,50.004 4.45734783,48.4473913 4.45734783,46.5280435 L4.45734783,7.4883913 C4.45734783,5.56904348 6.01395652,4.01243478 7.93447826,4.01243478 L45.9328696,4.01243478 C47.8533913,4.01243478 49.4088261,5.56904348 49.4088261,7.4883913 L49.41,46.5280435 L49.41,46.5280435 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4928696,17.5852174 C25.124087,17.5852174 24.2213478,17.7166957 23.7013043,17.8493478 L23.7013043,26.6302174 C24.2953043,26.7628696 24.9926087,26.8063043 25.9634348,26.8063043 C29.538,26.8063043 31.7437832,24.9961304 31.7437832,21.9533478 C31.7449565,19.2169565 29.8455652,17.5852174 26.4928696,17.5852174 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9328696,6.46473913 L7.93447826,6.46473913 C7.36865217,6.46473913 6.90847826,6.92256522 6.90847826,7.48956522 L6.90847826,46.5292174 C6.90847826,47.0926957 7.36747826,47.5540435 7.93447826,47.5540435 L45.9328696,47.5540435 C46.4975217,47.5540435 46.9576957,47.0938696 46.9576957,46.5292174 L46.9576957,7.4883913 C46.9576957,6.92256522 46.4986957,6.46473913 45.9328696,6.46473913 Z M35.681087,28.8383478 C33.3884348,30.9995217 29.9793913,31.9703478 26.0068696,31.9703478 C25.1252609,31.9703478 24.3704348,31.9257391 23.7013043,31.8376957 L23.7013043,42.4991739 L17.0886522,42.4991739 L17.0886522,13.1278696 C19.1688261,12.7745217 22.0613478,12.5092174 26.1653478,12.5092174 C30.3139565,12.5092174 33.2628261,13.3039565 35.2502609,14.8934348 C37.1461304,16.3925217 38.4233478,18.8647826 38.4233478,21.776087 C38.4233478,24.690913 37.449,27.1631739 35.681087,28.8383478 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingIc);
export default __webpack_public_path__ + "static/media/parking_ic.37c6bddb.svg";
export { ForwardRef as ReactComponent };